// Shape profiles — reusable border-radius sets for card components
// Each profile defines radii for different UI elements so themes
// can change the 'feel' from round/pill to square/blocky to angled.

export const SHAPES = {
    // Default: soft rounded (current standard themes)
    rounded: {
        card: "20px",
        cardInner: "14px",
        taskRow: "20px",
        chip: "50px",
        avatar: "50%",
        button: "50px",
        dialog: "24px",
        input: "12px",
        sectionGap: "12px",
    },

    // Sharp/blocky: super themes, gaming aesthetics
    square: {
        card: "8px",
        cardInner: "6px",
        taskRow: "8px",
        chip: "6px",
        avatar: "12px",
        button: "8px",
        dialog: "12px",
        input: "4px",
        sectionGap: "8px",
    },

    // Angled: chamfered corners (like Pokemon cards)
    angled: {
        card: "4px 20px 4px 20px",
        cardInner: "2px 12px 2px 12px",
        taskRow: "4px 16px 4px 16px",
        chip: "4px 50% 4px 50%",
        avatar: "8px",
        button: "4px 50% 4px 50%",
        dialog: "4px 24px 4px 24px",
        input: "4px",
        sectionGap: "10px",
    },

    // Soft pill: extra rounded, bubble-like
    pill: {
        card: "50px",
        cardInner: "16px",
        taskRow: "50px",
        chip: "50px",
        avatar: "50%",
        button: "50px",
        dialog: "32px",
        input: "16px",
        sectionGap: "14px",
    },

    // Retro: 8-bit pixel feel (sharp with slight inset)
    retro: {
        card: "4px",
        cardInner: "2px",
        taskRow: "4px",
        chip: "4px",
        avatar: "4px",
        button: "4px",
        dialog: "4px",
        input: "0px",
        sectionGap: "6px",
    },

    // Crystal: geometric faceted look
    crystal: {
        card: "12px",
        cardInner: "8px",
        taskRow: "12px",
        chip: "8px",
        avatar: "12px",
        button: "10px",
        dialog: "16px",
        input: "8px",
        sectionGap: "10px",
    },
};

export const DEFAULT_SHAPE = SHAPES.rounded;
